import React from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Typography from "@material-ui/core/Typography";
import { ShowController, TitleForRecord } from "react-admin";

export const styles = {
  root: {
    display: "flex"
  },
  card: {
    flex: "1 1 auto"
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em"
  }
};

const sanitizeRestProps = ({
  actions,
  aside,
  title,
  children,
  className,
  crudGetOne,
  id,
  data,
  isLoading,
  resource,
  hasCreate,
  hasEdit,
  hasList,
  hasShow,
  translate,
  version,
  match,
  location,
  history,
  options,
  locale,
  permissions,
  showTitle,
  ...rest
}) => rest;

export const ShowView = ({
  actions,
  aside,
  basePath,
  children,
  classes,
  className,
  defaultTitle,
  hasEdit,
  hasList,
  isLoading,
  record,
  resource,
  title,
  version,
  showTitle,
  ...rest
}) => {
  if (!children) {
    return null;
  }
  return (
    <div
      className={classnames("show-page", classes.root, className)}
      {...sanitizeRestProps(rest)}
    >
      <TitleForRecord
        title={title}
        record={record}
        defaultTitle={defaultTitle}
      />
      <Card className={classes.card}>
        <div className={classes.title}>
          <Typography variant="title">{showTitle}</Typography>
        </div>
        {record &&
          React.cloneElement(children, {
            resource,
            basePath,
            record,
            version
          })}
      </Card>
      {aside &&
        React.cloneElement(aside, {
          resource,
          basePath,
          record,
          version
        })}
    </div>
  );
};

ShowView.propTypes = {
  aside: PropTypes.node,
  basePath: PropTypes.string,
  children: PropTypes.element,
  classes: PropTypes.object,
  className: PropTypes.string,
  defaultTitle: PropTypes.any,
  hasEdit: PropTypes.bool,
  hasList: PropTypes.bool,
  isLoading: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  title: PropTypes.any,
  version: PropTypes.number,
  showTitle: PropTypes.string
};

ShowView.defaultProps = {
  classes: {}
};

export const Show = props => (
  <ShowController {...props}>
    {controllerProps => <ShowView {...props} {...controllerProps} />}
  </ShowController>
);

Show.propTypes = {
  actions: PropTypes.element,
  aside: PropTypes.node,
  children: PropTypes.element,
  classes: PropTypes.object,
  className: PropTypes.string,
  hasCreate: PropTypes.bool,
  hasEdit: PropTypes.bool,
  hasList: PropTypes.bool,
  hasShow: PropTypes.bool,
  id: PropTypes.any.isRequired,
  resource: PropTypes.string.isRequired,
  title: PropTypes.any
};

export default withStyles(styles)(Show);
